export default "__VITE_ASSET__BrCOcacM__"